import React, { Fragment, useState } from "react";

import PubNub from "pubnub";
import { PubNubProvider, PubNubConsumer } from "pubnub-react";

const channels = ["space_ac4e67b98b34b44c4a39466e93e"];

const pubnub = new PubNub({
  publishKey: "pub-c-237e3509-e2cf-4bf6-a634-071668032cdb",
  subscribeKey: "sub-c-65167594-ae8f-11ea-adee-16aa024ec639",
  uuid: " ",
});

export default function PubNubApp() {
  const [messages, addMessage] = useState([]);
  const [message, setMessage] = useState("");
  let oldMessages = [];
  // pubnub.fetchMessages(
  //   {
  //     channels: [channels],
  //     // end: "15343325004275466",
  //     count: 10,
  //   },
  //   (status, response) => {
  // handle response
  // oldMessages = response.channels[channels[0]];
  // addMessage([...messages, message[0]]);
  // {
  //   oldMessages.map((message, messageIndex) => {
  //     return (
  //       <div
  //         key={`message-${messageIndex}`}
  //         style={{
  //           display: "block",
  //           width: "100%",
  //           float: "left",
  //           backgroundColor: "#eee",
  //           color: "black",
  //           borderRadius: "20px",
  //           margin: "5px",
  //           padding: "8px 15px",
  //         }}
  //       >
  //         {message.author}
  //         {message.content}
  //       </div>
  //     );
  //   });
  // }
  // }

  // console.log(oldMessages);
  // );

  const sendMessage = (message) => {
    pubnub.publish(
      {
        channel: channels[0],
        message: {
          type: "text",
          senderId: "user_00505cca5b04460fafd716af48665ca1",
          text: message,
          // id: Math.random().toString(16).substr(2),
        },
      },
      () => setMessage("")
    );
  };

  return (
    <PubNubProvider client={pubnub}>
      <div className="App">
        <header className="App-header">
          <PubNubConsumer>
            {(client) => {
              client.addListener({
                message: (messageEvent) => {
                  addMessage([...messages, messageEvent.message]);
                },
              });

              client.subscribe({ channels });
            }}
          </PubNubConsumer>
          <div
            style={{
              width: "370px",
              height: "300px",
              border: "1px solid black",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          >
            <div style={{ backgroundColor: "grey" }}>Chat with Driver</div>
            <div
              style={{
                backgroundColor: "white",
                height: "260px",
                overflow: "scroll",
              }}
            >
              {messages.map((message, messageIndex) => {
                return (
                  <div
                    key={`message-${messageIndex}`}
                    style={{
                      display: "block",
                      width: "90%",
                      float: "left",
                      backgroundColor: "#eee",
                      color: "black",
                      borderRadius: "20px",
                      margin: "5px",
                      padding: "8px 15px",
                    }}
                  >
                    {console.log(message)}
                    {message.sender_id}
                    {message.text}
                  </div>
                );
              })}
            </div>
            <div
              style={{
                display: "flex",
                height: "40px",
                backgroundColor: "lightgrey",
              }}
            >
              <input
                type="text"
                style={{
                  borderRadius: "5px",
                  flexGrow: 1,
                  fontSize: "18px",
                }}
                placeholder="Type your message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button
                style={{
                  backgroundColor: "blue",
                  color: "white",
                  borderRadius: "5px",
                  fontSize: "16px",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  sendMessage(message);
                }}
              >
                Send Message
              </button>
            </div>
          </div>
        </header>
      </div>
    </PubNubProvider>
  );
}

// export default App;
